import StudioDefaultName from './DefaultName';

/**
 * @type { import("didi").ModuleDeclaration }
 */
export default {
  __init__: ['studioDefaultName'],
  studioDefaultName: ['type', StudioDefaultName]
};
